var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info d-inline-flex align-items-center",attrs:{"role":"button"}},[_c('z-icon',{attrs:{"name":"Info","variant":"active","size":"16"}}),_c('div',{staticClass:"link"},[_vm._v(" Cómo preparar un paquete ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }